module.exports = __webpack_public_path__ + "static/img/null.aca3b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/null.png
// module id = 3qAc
// module chunks = 1